import { render, staticRenderFns } from "./OurGirls.vue?vue&type=template&id=8c3d4fb6"
import script from "./OurGirls.vue?vue&type=script&lang=js"
export * from "./OurGirls.vue?vue&type=script&lang=js"
import style0 from "./OurGirls.vue?vue&type=style&index=0&id=8c3d4fb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports